import { FilterOptions } from '@recruiting-solutions/rs-shared';
import { initializeApp } from 'firebase/app';
import { getFunctions } from 'firebase/functions';
import { JobService, SearchService } from '@recruiting-solutions/search-ui-shared';

class SearchUi {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async init(
        hostingEnvironment: string,
        _isFirebaseLocal = false,
        searchOptions?: {
            defaultOrder?: { isDesc: boolean; orderBy: string };
            useLanguageFilter?: boolean;
            pageSize?: number;
            searchRadius?: number;
            appendLocaleToFilters?: boolean;
            brandFilters?: FilterOptions[];
            getCountryCodes?: () => Promise<string>;
            searchUrl?: string;
            useProxy?: boolean;
        },
    ) {
        this.initializeFirebase(hostingEnvironment);
        SearchService.init(searchOptions);
        JobService.loadJob();
    }

    initializeFirebase(hostingEnvironment: string) {
        let firebaseConfig;
        switch (hostingEnvironment) {
            case 'Production':
                firebaseConfig = {
                    apiKey: 'AIzaSyCri8CpGF4DCQc79NMc5BreySAJ4QKIbDc',
                    authDomain: 'csbep-75ff0.firebaseapp.com',
                    databaseURL: 'https://csbep-75ff0.firebaseio.com',
                    projectId: 'csbep-75ff0',
                    storageBucket: 'csbep-75ff0.appspot.com',
                    messagingSenderId: '810652930634',
                    appId: '1:810652930634:web:0925fee9561446f6058cb3',
                    measurementId: 'G-FN4MSQTPPL',
                };
                break;
            case 'dmProd':
                //TODO: add setting for DM PROD!!!
                firebaseConfig = {
                    apiKey: "AIzaSyCGtNvnLPWxJ8s4hxlDsHtb8uADLENNvRA",
                    authDomain: "login.dm-jobs.com",
                    databaseURL: "https://firmen-karriereseite.firebaseio.com",
                    projectId: "firmen-karriereseite",
                    storageBucket: "firmen-karriereseite.appspot.com",
                    messagingSenderId: "446966163417",
                    appId: "1:446966163417:web:105fa6f8a647cadc5edbc8"
                };
                break;
            case 'Staging':
            default:
                firebaseConfig = {
                    apiKey: 'AIzaSyCSDkHP3iGqudjNjkj8zRvBB1QRf9yDZkc',
                    authDomain: 'csbcomponents.firebaseapp.com',
                    databaseURL: 'https://csbcomponents.firebaseio.com',
                    projectId: 'csbcomponents',
                    storageBucket: 'csbcomponents.appspot.com',
                    messagingSenderId: '994263864702',
                    appId: '1:994263864702:web:792edff32b3daf490a4f2f',
                    measurementId: 'G-GNDFKPKBBS',
                };
                break;
        }
        if (firebaseConfig) {
            const firebaseApp = initializeApp(firebaseConfig);
            const fireFunctions = getFunctions(firebaseApp);
            fireFunctions.region = 'europe-west1';
        }
    }
}
export const searchUI = new SearchUi();
